import React from 'react';
import {IndexLink, Link} from 'react-router';


export default class Splash_Project_Term extends React.Component {
    render() {
        return (
            <div className="page_wrapper">
				<p className="text_paragraph">
					<p className={"title"}>
						<h2>Terms and Conditions - Versity</h2>
						<small>Last updated: September 6, 2023</small>
					</p>
					<br/>
					<strong>Welcome to Versity!</strong><br/>
					Thank you for choosing Versity. Our platform connects students with employers in a crowdsourced manner. Please review these Terms and Conditions ("Terms") carefully, as they outline the guidelines for using our platform.<br/>
					<br/>
					<strong>1. Eligibility</strong><br/>
					Access to and use of Versity is available to individuals who are at least 18 years old. By accessing or using our platform, you confirm that you meet this eligibility requirement.<br/>
					<br/>
					<strong>2. User Agreement</strong><br/>
					By using Versity, you agree to abide by these Terms. We may update these Terms periodically, and your continued use of our services constitutes your acceptance of any changes. In addition to these Terms, your usage of Versity is subject to our User Agreement and Privacy Policy, both of which may be revised over time and are incorporated into these Terms by reference.<br/>
					<br/>
					<strong>3. Disclaimer</strong><br/>
					Versity does not endorse any students or employers and is not responsible for any content, data, advertising, products, goods, or services offered by them. We do not guarantee the success of any projects or services and do not provide any form of insurance coverage.<br/>
					<br/>
					<strong>Students and Employers</strong><br/>
					Employers using Versity retain ownership rights to the work produced by students. <br/>
					<br/>
					<strong>Versity's Role</strong><br/>
					Versity does not guarantee or promise any specific outcomes or results from using our platform. We do not evaluate, approve, or endorse any user profiles or the materials and services offered by them. It is the responsibility of users to conduct their own research and due diligence before engaging in any collaboration.<br/>
					<br/>
					<strong>4. Ratings and Reviews</strong><br/>
					Versity allows users to submit ratings and reviews of each other. These ratings and reviews represent the opinions of the users who submit them and do not necessarily reflect the views of Versity. Users are expected to provide accurate and honest feedback.<br/>
					<br/>
					<strong>5. Termination</strong><br/>
					Versity reserves the right to terminate or suspend access to the platform for any user who violates these Terms or engages in conduct that is not in the best interests of Versity.<br/>
					<br/>
					<strong>Conclusion</strong><br/>
					Versity is committed to providing a platform that fosters collaboration between students and employers while ensuring the correct ownership of work. If you have any questions or concerns regarding these Terms and Conditions, please feel free to contact us.<br/>
					<br/>
					Thank you for choosing Versity!
					<br/>
				</p>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_project_term.js
 **/